// extracted by mini-css-extract-plugin
export default {"title":"RegistrationSection_title__8ych4","regnInfoText":"RegistrationSection_regnInfoText__+mjH6","jumbo":"RegistrationSection_jumbo__trN24"};